import { createFileRoute } from '@tanstack/react-router'
import { parse } from 'valibot'

import { fetchTaxCategory } from '@/features/tax-categories/api'

import { TaxCategoryParamsSchema } from '../-models/tax-category-params'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/_system-master-settings/tax-categories/$taxCategoryId'
)({
  parseParams: (params) => parse(TaxCategoryParamsSchema, params),
  loader: async ({
    abortController,
    params: { tenantKey, taxCategoryId },
    context: { auth }
  }) => {
    return {
      authUser: auth.user,
      taxCategory: await fetchTaxCategory(
        { tenantKey, taxCategoryId },
        abortController.signal
      )
    }
  },
  meta: ({ loaderData }) => [{ title: loaderData.taxCategory.name }]
})
